import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Routes, Router } from '@angular/router';
import { RoutesService } from '../../services/routes.service';
import { NicaMenuService } from '../../services/nica-menu.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DxDrawerComponent, DxListComponent, getElement } from 'devextreme-angular';
import { environment } from '../../../environments/environment';



@Component({
  selector: 'app-nica-main-menu',
  templateUrl: './nica-main-menu.component.html',
  styleUrls: ['./nica-main-menu.component.css']

})
export class NicaMainMenuComponent implements OnInit {
  private menuUrl = 'assets/main.json';
  @ViewChild("mainmenu", { static: false }) mainmenu: DxListComponent


  @Input() active: boolean
  @Input() menuWidth;
  @Input() menuType

  @Output() seleziona: EventEmitter<any> = new EventEmitter<any>();
  @Output() reset: EventEmitter<any> = new EventEmitter<any>();

  menu: any;
  menuUtility: any[] = [];
  SubItem: [];
  showItems: boolean;
  showSubItems: any = []

  text: string;
  numMenu: number;
  sideWidth: string;
  imageUrl = environment.BASE_API_URL
  elementAttr: any;
  childWidth: any;
  focusCSS: boolean;



  /*****************************/

  constructor(private ruote: Router, private http: HttpClient, private menuService: NicaMenuService) { }

  ngOnInit() {

    this.menuService.getMenu().then(res => {
      //console.log(('NicaMainMenuComponent--->', res)
      this.menu = res;
      // this.menuUtility = this.menu.filter(res=>res.id=='D')
      //this.menu=this.menu.filter(res=>res.id!='D')
      this.initializzed();
    });


    //this.menuService.setPreferiti(this.menu)
    /* this.menu = this.menuService.menuMain.subscribe(menu=>{
     
       
       
     
     })*/


    this.numMenu = 1;
    this.sideWidth = ''

    //this.initializzed();
  }




  /****Funzioni****/

  selectItem(ev: any) {
    //console.log((ev)
    this.initializzed();

    const Items = ev;
    //console.log((Items)
    this.seleziona.emit(Items)
    //this.initializzed();


  }
  selectItemButton(ev, item) {
    ev.itemData = item
    this.selectItem(ev)
  }

  initializzed() {

    for (let i = 0; i < this.menu.length; i++) {
      this.menu[i].active = false;
    }

    this.menuService.setVariabili(this.menu);
  }
  hideList(ev) {


    //this.defaultVisible = !this.defaultVisible

    /*const bodyHasClass = document.body.classList.contains('enlarge-menu-all');
    if (bodyHasClass) {
      document.body.classList.remove('enlarge-menu-all');

    } */


    this.reset.emit()
  }

  /****Tipo menu 2****/
  selectSubItem(e, i, item) {
    //console.log((this.showSubItems)
    //this.showSubItems[i - 1] = false;
    //this.showSubItems[i + 1] = false;
    this.showSubItems = [];
    //this.showSubItems[i] = !this.showSubItems[i]

    // //console.log((this.showSubItems)
    if (!this.showSubItems[i] || typeof this.showSubItems[i] == 'undefined') {
      ////console.log((this.showSubItems[i])
      this.showSubItems[i] = true;

      e.itemData = item
      this.selectItem(e)
      document.body.classList.remove('enlarge-menu-all');
    } else {
      // document.body.classList.add('enlarge-menu-all');
      this.showSubItems[i] = false
      e.itemData = item
      this.selectItem(e)
    }
  }




}
